import React, { useState } from "react";
import ReportingDisplay from "./ReportingDisplay";
import EmployeeReportingDisplay from "./EmployeeReportingDisplay";
import AIReportingDisplay from "./AIReportingDisplay";

// The combined "Analytics" tab: Store Analytics and Employee Analytics are
// sub-views behind a segmented switcher in the title bar, and the AI Insights
// chat is reached via a header button (mirroring KnowledgeHubDisplay — the
// chat unmounts on back, so the conversation resets; switching sub-views
// likewise resets the other view's filters).
//
// Module-scoped so the last-viewed analytics type survives navigating away
// and back within a session (the wrapper unmounts when the user leaves the
// tab, so component state alone would forget it).
let lastAnalyticsView = "store";

export default function AnalyticsHubDisplay(props) {
  // props.initialView is only passed by the legacy `employeeReporting` tab
  // route so anything still pointing there lands on the Employee view; the
  // main `reporting` route omits it and picks up the remembered view.
  const [analyticsView, setAnalyticsView] = useState(
    props.initialView || lastAnalyticsView
  );
  const [activeView, setActiveView] = useState("analytics"); // "analytics" | "ai"

  const switchAnalyticsView = (view) => {
    lastAnalyticsView = view;
    setAnalyticsView(view);
  };

  const sharedProps = {
    homeStore: props.homeStore,
    homeCompany: props.homeCompany,
    storeOptions: props.storeOptions,
    storeNames: props.storeNames,
    userId: props.userId,
  };

  if (activeView === "ai" && props.aiReportingEnabled) {
    return (
      <AIReportingDisplay
        {...sharedProps}
        onBack={() => setActiveView("analytics")}
        backLabel="Analytics"
      />
    );
  }

  const analyticsSwitcher = (
    <div
      role="group"
      aria-label="Analytics type"
      className="inline-flex rounded-lg border border-slate-200 bg-white p-1"
    >
      {[
        ["store", "Store"],
        ["employee", "Employee"],
      ].map(([value, label]) => (
        <button
          key={value}
          type="button"
          aria-pressed={analyticsView === value}
          onClick={() => switchAnalyticsView(value)}
          className={`rounded-md px-3 py-1 text-sm font-medium transition-colors ${
            analyticsView === value
              ? "bg-violet-700 text-white"
              : "text-slate-600 hover:bg-slate-50"
          }`}
        >
          {label}
        </button>
      ))}
    </div>
  );

  const AnalyticsComponent =
    analyticsView === "employee" ? EmployeeReportingDisplay : ReportingDisplay;

  return (
    <AnalyticsComponent
      {...sharedProps}
      analyticsSwitcher={analyticsSwitcher}
      onOpenAIInsights={
        props.aiReportingEnabled ? () => setActiveView("ai") : undefined
      }
    />
  );
}
